import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PageTitle = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const titles = {
      "/": t("home.title"),
      "/contact": t("contact.title"),
      "/about-us": t("about.title"),
      "/sell-fc-coins-safely": t("sellCoinsSafely.title"),
      "/cheap-fc-coins": t("cheapCoins.title"),
      "/sell-fc-coins": t("sellCoins.title"),
      "/buy-fc-coins": t("buyCoinss.title"),
      "/blog": t("blog.title"),
      "/sells": t("sellss.title"),
      "/signin": t("signin.title"),
      "/signup": t("signup.title"),
      "/faq-v1": t("faqV1.title"),
      "/faq-v2": t("faqV2.title"),
      "/our-team": t("ourTeamm.title"),
      "/collection": t("collection.title"),
      "/item-details/:id": t("itemDetails.title"),
      "/payment-page/:id": t("paymentPage.title"),
      "/successful/:id/:type": t("successful.title"),
      "/blog-details": t("blogDetails.title"),
      "/testimonial": t("testimonial.title"),
      "/comming-soon": t("comingSoon.title"),
      "/page-404": t("page404.title"),
    };

    const descriptions = {
      "/": t("home.description"),
      "/contact": t("contact.description"),
      "/about-us": t("about.description"),
      "/sell-fc-coins-safely": t("sellCoinsSafely.description"),
      "/cheap-fc-coins": t("cheapCoins.description"),
      "/sell-fc-coins": t("sellCoins.description"),
      "/buy-fc-coins": t("buyCoinss.description"),
      "/blog": t("blog.description"),
      "/sells": t("sellss.description"),
      "/signin": t("signin.description"),
      "/signup": t("signup.description"),
      "/faq-v1": t("faqV1.description"),
      "/faq-v2": t("faqV2.description"),
      "/our-team": t("ourTeamm.description"),
      "/collection": t("collection.description"),
      "/item-details/:id": t("itemDetails.description"),
      "/payment-page/:id": t("paymentPage.description"),
      "/successful/:id/:type": t("successful.description"),
      "/blog-details": t("blogDetails.description"),
      "/testimonial": t("testimonial.description"),
      "/comming-soon": t("comingSoon.description"),
      "/page-404": t("page404.description"),
    };

    const keywords = {
      "/": t("home.keywords"),
      "/contact": t("contact.keywords"),
      "/about-us": t("about.keywords"),
      "/sell-fc-coins-safely": t("sellCoinsSafely.keywords"),
      "/cheap-fc-coins": t("cheapCoins.keywords"),
      "/sell-fc-coins": t("sellCoins.keywords"),
      "/buy-fc-coins": t("buyCoinss.keywords"),
      "/blog": t("blog.keywords"),
      "/sells": t("sellss.keywords"),
      "/signin": t("signin.keywords"),
      "/signup": t("signup.keywords"),
      "/faq-v1": t("faqV1.keywords"),
      "/faq-v2": t("faqV2.keywords"),
      "/our-team": t("ourTeamm.keywords"),
      "/collection": t("collection.keywords"),
      "/item-details/:id": t("itemDetails.keywords"),
      "/payment-page/:id": t("paymentPage.keywords"),
      "/successful/:id/:type": t("successful.keywords"),
      "/blog-details": t("blogDetails.keywords"),
      "/testimonial": t("testimonial.keywords"),
      "/comming-soon": t("comingSoon.keywords"),
      "/page-404": t("page404.keywords"),
    };

    document.title = titles[location.pathname] || t("default.title");
    
    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
        descriptionMeta.setAttribute("content", descriptions[location.pathname] || t("default.description"));
    }

    const keywordsMeta = document.querySelector('meta[name="keywords"]');
    if (keywordsMeta) {
        keywordsMeta.setAttribute("content", keywords[location.pathname] || t("default.keywords"));
    }

  }, [location.pathname, t]);

  return null; // No UI needed
};

export default PageTitle;